import { createShallowStore, createStoreWithSubscribe } from '@frontend/store';
import { CallIntelDemoTriggerSource } from '../types';

interface CallIntelDemoState {
  isDemoAccount: boolean;
  isDemoModal: boolean;
  demoDataReadyMap: Partial<Record<CallIntelDemoTriggerSource, boolean>>;

  setIsDemoAccount: (isDemoAccount: boolean) => void;
  setIsDemoModal: (isDemoModal: boolean) => void;
  setIsDemoDataReady: (demoSource: CallIntelDemoTriggerSource, isDemoDataReady: boolean) => void;
}

const useCallIntelDemoStore = createStoreWithSubscribe<CallIntelDemoState>(
  (set) => ({
    isDemoAccount: false,
    isDemoModal: false,
    demoDataReadyMap: {},

    setIsDemoAccount: (isDemoAccount) => {
      set({ isDemoAccount });
    },
    setIsDemoModal: (isDemoModal) => {
      set({ isDemoModal });
    },
    setIsDemoDataReady: (demoTriggerSource: CallIntelDemoTriggerSource, isDemoDataReady: boolean) => {
      set((state) => ({
        demoDataReadyMap: {
          ...state.demoDataReadyMap,
          [demoTriggerSource]: isDemoDataReady,
        },
      }));
    },
  }),
  {
    name: 'CallIntelDemoStore',
    trace: true,
  }
);

export const useCallIntelDemoShallowStore = createShallowStore<CallIntelDemoState>(useCallIntelDemoStore);
